import { Outlet } from "react-router-dom";
// import Events from "./homecomponents/Events";
import Events from "./homecomponents/Event-Backup";
import UpcomingEvents from "./homecomponents/UpcomingEvents";
import PopularCities from "./homecomponents/PopularCities";
import Reviews from "./homecomponents/Reviews";
import Banner from "./homecomponents/Banner";
import { Blogs } from "./homecomponents/Blogs";
import { Video } from "./homecomponents/Video";
import React, { useEffect, useState } from "react";
import { clearFormValues, RestfullApiService } from "../config/service";
import EventCategory from "./homecomponents/EventCategory";
import { useSelector } from "react-redux";

const Home = () => {
  const user = useSelector((state) => state.user.userProfile);

  const [fetchingDashbboard, setFetchingDashboard] = useState(false);
  const [eventtable, setEventTable] = useState([]);
  const [popularcitytable, setPopularCityTable] = useState([]);
  const [blogstable, setBlogsTable] = useState([]);
  const [upcomingeventtable, setUpcomingeventTable] = useState([]);
  const [reviewtable, setReviewTable] = useState([]);
  const [eventtypetable, setEventtypeTable] = useState([]);
  const [bannertable, setBannerTable] = useState([]);
  const [youtubeVideos, setYoutubeVideos] = useState([]);

  async function loaddashboard() {
    const reqdata = {
      Method_Name: "homepage",
      SearchBy: user?.Participant_Id ?? "",
    };
    try {
      setFetchingDashboard(true);
      const result = await RestfullApiService(
        reqdata,
        "participant/dashboard",
        0
      );
      // console.log(result?.data?.);
      if (result) {
        setEventTable(result?.data?.Result?.Table1);
        setPopularCityTable(result?.data?.Result?.Table2);
        setBlogsTable(result?.data?.Result?.Table3);
        setReviewTable(result?.data?.Result?.Table4);
        setUpcomingeventTable(result?.data?.Result?.Table5);
        setEventtypeTable(result?.data?.Result?.Table6);
        setBannerTable(result?.data?.Result?.Table7);
        setYoutubeVideos(result?.data?.Result?.Table8);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setFetchingDashboard(false);
    }
  }

  useEffect(() => {
    clearFormValues();
    window.scrollTo({ top: 0, behavior: "smooth" });

    // const firstReload = localStorage.getItem("firstReload");
    // if (!firstReload) {
    //   window.location.reload();
    //   localStorage.setItem("firstReload", 1);
    // }
    // window.location.reload();

    loaddashboard();
    localStorage.removeItem("navigateSelectedCategory");
    localStorage.removeItem("navigateSelectedCity");

    return () => {
      localStorage.removeItem("firstReload");
    };
  }, []);

  return (
    <>
      <main>
        {/* {fetchingDashbboard && <PreLoader />} */}
        {/* {!fetchingDashbboard && ( */}
        <>
          {/* <Header /> */}
          <Banner
            bannertable={bannertable}
            fetchingDashbboard={fetchingDashbboard}
          />
          <UpcomingEvents upcomingeventtable={upcomingeventtable} />
          {eventtable?.length > 0 ? <Events eventtable={eventtable} /> : <></>}
          <PopularCities popularcitytable={popularcitytable} />
          {reviewtable?.length > 0 ? (
            <Reviews
              reviewtable={reviewtable}
              fetchingDashbboard={fetchingDashbboard}
            />
          ) : (
            <></>
          )}
          <EventCategory eventtypetable={eventtypetable} />
          <Blogs blogstable={blogstable} />
          <Video youtubeVideos={youtubeVideos} />
          <Outlet />
        </>
        {/* )} */}
        {/* <Footer /> */}
      </main>
    </>
  );
};
export default Home;
